/**
 * DCMS FRONTEND API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CommunicationKindEnum } from './communicationKindEnum';
import { CommunicationDirectionEnum } from './communicationDirectionEnum';
import { CommunicationChannelEnum } from './communicationChannelEnum';
import { CommunicationStatusEnum } from './communicationStatusEnum';
import { CommunicationRecipient } from './communicationRecipient';


/**
 * One row of the patient file\'s communication tab: one email, whoever else got it too, or a help-desk conversation.
 */
import {ValidatorFn, Validators} from "@angular/forms";

export interface CommunicationEntry { 
    readonly id: number;
    readonly channel: CommunicationChannelEnum;
    readonly direction: CommunicationDirectionEnum;
    readonly kind: CommunicationKindEnum;
    readonly status: CommunicationStatusEnum;
    readonly occurredAt: string;
    readonly subject: string;
    readonly sender: string;
    readonly recipients: Array<CommunicationRecipient>;
    readonly appointment: number | null;
    readonly durationMinutes: number | null;
    readonly note: string;
    readonly createdByName: string | null;
    readonly isManual: boolean;
    readonly hasContent: boolean;
    readonly inbox: string;
    readonly startedAt: string | null;
    readonly assistantOnly: boolean;
    readonly helpdeskUrl: string;
}
export namespace CommunicationEntry {
}

export const CommunicationEntry_id_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const CommunicationEntry_channel_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const CommunicationEntry_direction_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const CommunicationEntry_kind_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const CommunicationEntry_status_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const CommunicationEntry_occurredAt_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const CommunicationEntry_subject_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const CommunicationEntry_sender_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const CommunicationEntry_recipients_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const CommunicationEntry_appointment_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const CommunicationEntry_durationMinutes_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const CommunicationEntry_note_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const CommunicationEntry_createdByName_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const CommunicationEntry_isManual_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const CommunicationEntry_hasContent_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const CommunicationEntry_inbox_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const CommunicationEntry_startedAt_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const CommunicationEntry_assistantOnly_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const CommunicationEntry_helpdeskUrl_Validators: ValidatorFn[] =
    [  Validators.required, ];


